module.exports = __webpack_public_path__ + "img/a-new-endeavor.fab98d6d.png";